<template>
  <div
    class="box-footer box-comments"
    style="display: block"
    v-if="comments"
  >
    <post-list-comment-item
      v-for="comment in comments"
      :key="comment.comment_id"
      :comment="comment"
    ></post-list-comment-item>
  </div>
</template>
<script>
export default {
  props: {
    comments: {
      type: Array,
      required: true,
    },
  },
};
</script>